/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const registerPushTokenResponseDataSchema = z.object({
  registered: z.boolean(),
});

export type IRegisterPushTokenResponseData = z.infer<typeof registerPushTokenResponseDataSchema>;

export const registerPushTokenResponseSchema = createApiResponseSchema(
  registerPushTokenResponseDataSchema,
) as z.ZodSchema<IAPI<IRegisterPushTokenResponseData>>;

export type IRegisterPushTokenResponse = IAPI<IRegisterPushTokenResponseData>;
